import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, random } from "remotion";
import React from "react";

// VFX: Glitch Logo Reveal
// Category: intros-outros · Tags: intro, logo, glitch, reveal, sting
export default function IntroGlitchLogoReveal1000Ms() {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  const t = frame / durationInFrames;
  const glitchPhase = 1 - Math.min(1, t * 1.3); // glitch settles
  const offsetR = (random(`gr-${Math.floor(frame / 2)}`) - 0.5) * 30 * glitchPhase;
  const offsetG = (random(`gg-${Math.floor(frame / 2)}`) - 0.5) * 30 * glitchPhase;
  const offsetB = (random(`gb-${Math.floor(frame / 2)}`) - 0.5) * 30 * glitchPhase;
  const sliceShift = (random(`sl-${Math.floor(frame / 1.5)}`) - 0.5) * 40 * glitchPhase;
  const opacity = interpolate(t, [0, 0.15, 1], [0, 1, 1]);

  const logoStyle: React.CSSProperties = {
    fontSize: 200, fontWeight: 900, fontFamily: "system-ui, sans-serif",
    letterSpacing: "-0.05em",
  };

  return (
    <AbsoluteFill style={{ background: "#0a0e1a", alignItems: "center", justifyContent: "center" }}>
      <div style={{ position: "relative", opacity, transform: `translateX(${sliceShift}px)` }}>
        <span style={{ ...logoStyle, color: "#ef4444", position: "absolute", inset: 0, transform: `translate(${offsetR}px, 0)`, mixBlendMode: "screen" }}>DIMUS</span>
        <span style={{ ...logoStyle, color: "#10b981", position: "absolute", inset: 0, transform: `translate(${offsetG}px, 0)`, mixBlendMode: "screen" }}>DIMUS</span>
        <span style={{ ...logoStyle, color: "#06b6d4", position: "absolute", inset: 0, transform: `translate(${offsetB}px, 0)`, mixBlendMode: "screen" }}>DIMUS</span>
        <span style={{ ...logoStyle, color: "#f8fafc" }}>DIMUS</span>
      </div>
      {/* Scan line */}
      {glitchPhase > 0.2 && (
        <div style={{
          position: "absolute", left: 0, right: 0,
          top: `${random(`sc-${Math.floor(frame / 3)}`) * 100}%`,
          height: 4, background: "rgba(255,255,255,0.5)",
          mixBlendMode: "overlay"
        }} />
      )}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
